import React from 'react';
import Container from "olive-react-myoneui/lib/Container";
import Profile from '../../components/student-dashboard/profile';
import { useParams } from "react-router-dom";

const PublicProfile = () => {

  let { slug } = useParams();
  return (
    <>
      <div className="main-inner-content w-100">
        <div className="dashboard-wrapper w-100 public-profile-container" style={{background: '#f2f4f7'}}>
          <Container fluid>
            <Profile className="profile-wrapper" public_id={slug} />
          </Container>
        </div>
      </div>
    </>
  );
}

export default PublicProfile;
